import React from 'react';

const FeaturesSection = () => {
  const features = [
    {
      icon: (
        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
        </svg>
      ),
      title: 'TCP и UDP туннели',
      description: 'Полная поддержка TCP и UDP протоколов. Идеально для игр, которые используют UDP для низкой задержки.',
    },
    {
      icon: (
        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
          <line x1="8" y1="21" x2="16" y2="21" />
          <line x1="12" y1="17" x2="12" y2="21" />
        </svg>
      ),
      title: 'Кроссплатформенный CLI',
      description: 'Клиент для Linux, macOS, Windows, Android и даже OpenWRT роутеров. Работает везде.',
    },
    {
      icon: (
        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
          <path d="M3 3v5h5" />
          <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
          <path d="M16 16h5v5" />
        </svg>
      ),
      title: 'Авто-реконнект',
      description: 'Автоматическое восстановление туннеля при обрывах связи. Никаких ручных перезапусков.',
    },
  ];

  return (
    <section id="features" className="py-24 bg-white dark:bg-dark-950 transition-colors duration-300">
      <div className="max-w-[1200px] mx-auto px-6">
        {/* Заголовок */}
        <div className="text-center max-w-[600px] mx-auto mb-16">
          <p className="text-[13px] font-semibold text-primary-500 uppercase tracking-[2px] mb-4">
            Возможности
          </p>
          <h2 className="text-[28px] sm:text-[32px] lg:text-[40px] font-bold text-gray-900 dark:text-white mb-4 tracking-[-0.5px]">
            Почему XN Connect?
          </h2>
          <p className="text-lg text-gray-700 dark:text-dark-500">
            Мы создали простой инструмент для геймеров, которые хотят 
            играть с друзьями без технических сложностей.
          </p>
        </div>

        {/* Сетка преимуществ */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-8 bg-gray-50 dark:bg-dark-900 border border-gray-300 dark:border-dark-800 rounded-2xl transition-all duration-300 hover:border-primary-500 hover:-translate-y-1"
            >
              <div className="w-12 h-12 bg-primary-500 rounded-xl flex items-center justify-center text-white mb-5">
                {typeof feature.icon === 'string' ? feature.icon : feature.icon}
              </div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2.5">
                {feature.title}
              </h3>
              <p className="text-[15px] text-gray-700 dark:text-dark-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
